import { Box, Icon, Image, Typography } from "@outschool/backpack";
import { faArrowUpRightFromSquare } from "@outschool/icons";
import { useTranslation } from "@outschool/localization";
import { transformedImageUrl } from "@outschool/media-urls";
import * as Routes from "@outschool/routes";
import SectionCls from "@outschool/section";
import { pastDurationString } from "@outschool/time";
import { useFeatureFlag } from "@outschool/ui-components-shared";
import { Link } from "@outschool/ui-legacy-component-library";
import { useIsMobile } from "@outschool/ui-utils";
import React, { FC } from "react";

const Section = new SectionCls();

interface ClassHeaderDetailsProps {
  section: {
    start_time: Date;
    end_time: Date;
    nextOngoingMeeting?: {
      start_time: Date;
    } | null;
  };
  activity: {
    uid: string;
    title: string;
    published_at: Date | null;
    isClub: boolean;
    is_ongoing_weekly: boolean;
    weekly_meetings: number | null;
    photo: {
      fileUrl: string;
    } | null;
  };
  userTimeZone: string;
}

const ClassHeaderDetails: FC<ClassHeaderDetailsProps> = ({
  activity,
  section,
  userTimeZone,
}) => {
  const classroomRedesignEnabled = useFeatureFlag(
    "aic-classroom-foyer-redesign",
  );
  const { t } = useTranslation(
    "ui-components-classroom\\components\\ClassHeaderDetails",
  );
  const isMobile = useIsMobile();
  const url = activity.photo?.fileUrl
    ? transformedImageUrl(activity.photo?.fileUrl, {
        w: 750,
        h: 395,
        fit: "crop",
      })
    : undefined;

  return (
    <Box
      flex
      sx={{
        flexDirection: "row",
        alignItems: "stretch",
        justifyContent: "space-between",
      }}
    >
      <div>
        <Typography variant="h3">{activity.title}</Typography>
        <div>
          {Section.isPast(section)
            ? pastDurationString(
                section.start_time,
                section.end_time,
                userTimeZone,
              )
            : Section.fullDurationString({
                activity,
                section,
                nextOngoingMeeting: section.nextOngoingMeeting,
                userTimeZone,
              })}
        </div>
        {Boolean(classroomRedesignEnabled) && (
          <Link to={Routes.activityPath(activity)}>
            {t("Visit class listing")} <Icon icon={faArrowUpRightFromSquare} />
          </Link>
        )}
      </div>
      {!isMobile && (
        <Image
          alt={activity.title}
          src={url}
          sx={{
            maxHeight: "7em",
            marginLeft: "1em",
          }}
        />
      )}
    </Box>
  );
};

export default ClassHeaderDetails;
